export interface EventHistoryApi {
  eventDate: string;
  userName: string;
  action: InspectionAuditActionsApi;
  metadata: EventMetadata[];
}

export interface EventMetadata {
  id: string;
  value: string;
}

export enum InspectionAuditActionsApi {
  InspectionCreated = 0,
  InspectionStateChanged = 1,
  GeneralInfoDetails_FieldChange = 3,
  GeneralInfoDetails_Creation = 4,
  GeneralInfoAdditionalFields_FieldRemoved = 5,
  GeneralInfoAdditionalFields_FieldCreated = 6,
  GeneralInfoAdditionalFields_FieldChangeValue = 7,
  GeneralInfoAdditionalFields_FieldChangeName = 8,
  InspectorAssigned = 9,
  InspectorUnassigned = 10,
  ReviewComment = 11,
  ReAssignInspector = 12,
}

export interface EventHistory {
  eventDate: string;
  userName: string;
  action: InspectionAuditActions;
  description: string[];
  document: EventHistoryDocument;
}

export interface EventHistoryDocument {
  id: string;
  name: string;
}

export enum InspectionAuditActions {
  InspectionCreated = "Inspection Created",
  InspectionStateChanged = "Inspection Status Change",
  GeneralInfoDetails = "Inspection Details",
  GeneralInfoAdditionalFields_FieldRemoved = "General Info Additional Fields Field Removed",
  GeneralInfoAdditionalFields_FieldCreated = "General Info Additional Fields Field Created",
  GeneralInfoAdditionalFields_FieldChangeValue = "Additional Info Details",
  GeneralInfoAdditionalFields_FieldChangeName = "General Info Additional Fields Field Change Name",
  InspectorAssigned = "Inspector Assigned",
  InspectorUnassigned = "Inspector Unassigned",
  ReviewComment = "Inspection Data Review",
  ReAssignInspector = "Inspection Re-Assigned",
}
